export type HashAlgorithm = "SHA-1" | "SHA-256" | "SHA-512";

export type HashOutput = {
  algorithm: HashAlgorithm;
  value: string;
};

function bufferToHex(buffer: ArrayBuffer) {
  return [...new Uint8Array(buffer)]
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function generateHashes(
  input: string,
  algorithms: HashAlgorithm[] = ["SHA-1", "SHA-256", "SHA-512"],
): Promise<HashOutput[]> {
  const bytes = new TextEncoder().encode(input);

  return Promise.all(
    algorithms.map(async (algorithm) => ({
      algorithm,
      value: bufferToHex(await crypto.subtle.digest(algorithm, bytes)),
    })),
  );
}
